import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrafficNewsComponent } from './components/traffic-news/traffic-news.component';
import { AAGoogleMapModule } from '../google-map/aa-google-map.module';
import { FormsModule } from '@angular/forms';
import { TrafficOptionsComponent } from './components/traffic-options/traffic-options.component';
import { AACoreModule } from '../aa-core/aa-core.module';

@NgModule({
  declarations: [
    TrafficNewsComponent,
    TrafficOptionsComponent
  ],
  imports: [
    FormsModule,
    AAGoogleMapModule,
    AACoreModule,
    CommonModule
  ]
})
export class TrafficNewsModule { }
